import React, { Component } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { connect } from 'react-redux';
import { userLogout } from '../../redux/modules/auth';
import { getFromStorage } from '../../utils/storage';
import apiUrl from '../../utils/apiUrl';
import { Spinner } from 'react-bootstrap';
import './styles/styles.scss';
// import { browserHistory } from 'react-router';

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout())
  };
}

class ConnectedSidebarMenuComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      signingOut: false
    };

    this.logout = this.logout.bind(this);
  }

  async logout() {

    this.setState({ signingOut: true });

    const localStorageToken = getFromStorage('nibi_admin_app');

    if (localStorageToken && localStorageToken.token) {

      const { token } = localStorageToken;
      const prom = await fetch(`${apiUrl}/signin/account/logout?token=${token}`);
      const json = await prom.json();

      if (json.success) this.props.userLogout();
    }

  }

  componentWillUnmount() {
    this.props.history.push('/');
  }

  render() {

    const { signingOut } = this.state;
    const { location, history } = this.props;

    return (
      <div className="sidebar-menu-component">
        <SideNav
          onSelect={(selected) => {
            if (location.pathname !== selected) history.push(selected);
          }}
        >
          <SideNav.Toggle />
          <SideNav.Nav defaultSelected={location.pathname}>

            <NavItem eventKey="/">
              <NavIcon>
                <i className="fas fa-chart-line" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Dashboard
              </NavText>
              <NavItem eventKey="/">
                <NavText>
                  General
                </NavText>
              </NavItem>
              <NavItem eventKey="/dashboard/retention">
                <NavText>
                  Mercadeo
                </NavText>
              </NavItem>
            </NavItem>

            <NavItem eventKey="/usuarios">
              <NavIcon>
                <i className="fas fa-users" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Usuarios
              </NavText>
              <NavItem eventKey="/usuarios">
                <NavText>
                  Ver Usuarios
                </NavText>
              </NavItem>
              <NavItem eventKey="/nibify">
                <NavText>
                  Nibify
                </NavText>
              </NavItem>
            </NavItem>

            <NavItem eventKey="/fundaciones">
              <NavIcon>
                <i className="fas fa-hand-holding-heart" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Fundaciones
              </NavText>
              <NavItem eventKey="/fundaciones">
                <NavText>
                  Ver Fundaciones
                </NavText>
              </NavItem>
              <NavItem eventKey="/fundaciones/desembolsos">
                <NavText>
                  Desembolsos
                </NavText>
              </NavItem>
              <NavItem eventKey="/fundaciones/programas">
                <NavText>
                  Programas
                </NavText>
              </NavItem>
              <NavItem eventKey="/fundaciones/productos">
                <NavText>
                  Productos
                </NavText>
              </NavItem>
            </NavItem>

            <NavItem eventKey="/comercios">
              <NavIcon>
                <i className="fas fa-store" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Comercios
              </NavText>
              <NavItem eventKey="/comercios">
                <NavText>
                  Ver Comercios
                </NavText>
              </NavItem>
              <NavItem eventKey="/comercios/desembolsos">
                <NavText>
                  Desembolsos
                </NavText>
              </NavItem>
              <NavItem eventKey="/comercios/productos">
                <NavText>
                  Productos
                </NavText>
              </NavItem>
            </NavItem>

            <NavItem eventKey="/blog">
              <NavIcon>
                <i className="far fa-newspaper" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Blog
              </NavText>
            </NavItem>

            <NavItem eventKey="/contabilidad">
              <NavIcon>
                <i className="fas fa-calculator" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Contabilidad
              </NavText>
            </NavItem>

            <NavItem eventKey="/pagos">
              <NavIcon>
                <i className="fas fa-money-bill-alt" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Pagos
              </NavText>
              <NavItem eventKey="/pagos">
                <NavText>
                  General
                </NavText>
              </NavItem>
              <NavItem eventKey="/pagos/agrupado">
                <NavText>
                  Agrupado
                </NavText>
              </NavItem>
              <NavItem eventKey="/pagos/suscripciones">
                <NavText>
                  Suscripciones
                </NavText>
              </NavItem>
            </NavItem>

            <div className="separator"></div>

            <NavItem eventKey="/admin">
              <NavIcon>
                <i className="fas fa-users-cog" style={{ fontSize: '1.75em' }} />
              </NavIcon>
              <NavText>
                Admin
              </NavText>
            </NavItem>

            <NavItem onSelect={this.logout}>
              <NavIcon>
                {
                  signingOut ?
                    <div style={{ marginTop: '5px' }}>
                      <Spinner animation="border" variant="warning" />
                    </div> :
                    <i className="fas fa-sign-out-alt" style={{ fontSize: '1.75em' }} />
                }
              </NavIcon>
              <NavText>
                {
                  signingOut ? '' : 'Cerrar sesión'
                }
              </NavText>
            </NavItem>

          </SideNav.Nav>
        </SideNav>
      </div>
    );
  }
}

const SidebarMenuComponent = connect(null, mapDispatchToProps)(ConnectedSidebarMenuComponent);

export default SidebarMenuComponent;
